import { Component, PropType, reactive } from 'vue';
import BaseSetupService from '@/setup/BaseSetupService';
import type OrderEntity from '@/entity/order/OrderEntity';

type Props = SetupProps<typeof OrderModalCandidateSetupService.props>

export default class OrderModalCandidateSetupService extends BaseSetupService<Props> {
	static readonly props = {
		orderId: {
			type: Number,
			required: true as const,
		},
		order: {
			type: Object as PropType<OrderEntity>,
			default: undefined,
		},
		filterProps: {
			type: Object,
			default: undefined,
		},
		listFooterActions: {
			type: Object as PropType<[]>,
			default: undefined,
		},

	};

	tempWorkerPagedListFilter!: Component;

	private readonly state = reactive({ filterOpened: true });

	get filterOpened () { return this.state.filterOpened; }
	set filterOpened (val) { this.state.filterOpened = val; }

	constructor (props: Props) {
		super(props);
		this.tempWorkerPagedListFilter = () => import('@/components/temp-worker/TempWorkerPagedListFilter.vue');
		this.registerBusEvent('close-filter', () => this.state.filterOpened = false);
		this.registerBusEvent('open-filter', () => this.state.filterOpened = true);
	}
}
